import React, { useState, useEffect } from "react";
import styled from "styled-components";

import NaviItem from "./NaviItem";

const MenuContainer = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 24px;
`;

/**
 * ナビゲーションメニューコンポーネント
 * @param {Array} items - メニュー項目の配列 [{label, path}, ...]
 * @param {string} defaultActive - デフォルトでアクティブにするメニュー項目のラベル
 * @param {function} onItemClick - メニュー項目クリック時のコールバック
 * @param {string} className - 追加のクラス名
 * @returns {JSX.Element}
 */
const NaviMenu = ({ 
  items = [],
  defaultActive = "",
  onItemClick,
  className = ""
}) => {
  const [activeItem, setActiveItem] = useState(defaultActive);

  useEffect(() => {
    if (defaultActive) {
      setActiveItem(defaultActive);
    } else if (items.length > 0) {
      // デフォルト値がない場合は最初の項目をアクティブに
      setActiveItem(items[0].label);
    }
  }, [defaultActive, items]);

  const handleItemClick = (label) => {
    setActiveItem(label);
    if (onItemClick) {
      onItemClick(label);
    }
  };

  return (
    <MenuContainer className={className}>
      {items.map((item, index) => {
        // アイテムがReactコンポーネントの場合はそのまま表示
        if (typeof item === 'object' && !React.isValidElement(item) && !item.label) {
          return <li key={index} className="u-row-center">{item.component}</li>;
        }
        
        // 通常のメニュー項目
        return (
          <NaviItem
            key={index}
            label={item.label}
            path={item.path}
            isActive={activeItem === item.label}
            onClick={() => handleItemClick(item.label)}
            className={item.className}
          />
        );
      })}
    </MenuContainer>
  );
};

export default NaviMenu; 